'use client';
import React, { Children } from 'react';
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  Link,
  Stack,
  useDisclosure,
  Image,
  Spacer,
} from '@chakra-ui/react';
import { LuMenu, LuX } from 'react-icons/lu';
import Logolight from '../images/quedemy-text-logo-rect-violet.png';
import LogoDark from '../images/quedemy-text-logo-rect-white.png';
import { ColorModeButton } from './ui/color-mode';

const links = [
  { label: 'Blogs', href: '/blog' },

  // { label: 'Projects', href: '/projects' },
  // { label: 'Masterclass', href: '/events' },
];

const NavLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <Link
    paddingInline={3}
    minHeight={8}
    rounded={'md'}
    href={href}
    fontWeight={'medium'}
    textDecoration={'none'}
    fontSize={'medium'}
    color={'gray.600'}
    _hover={{
      color: 'brand.500',
    }}
    _dark={{
      color: 'gray.300',
      _hover: { color: 'brand.400' },
    }}
  >
    {children}
  </Link>
);

const NavbarContent = () => {
  const { open, onToggle } = useDisclosure();
  return (
    <>
      <Box
        as="header"
        position="sticky"
        top={0}
        zIndex={10}
        backgroundColor="white/60"
        backdropFilter="saturate(180%) blur(20px)"
        // borderBottomWidth="1px"
        // boxShadow={"sm"}
        _dark={{
          backgroundColor: 'black/60',
        }}
      >
        <Flex
          maxW="7xl"
          mx="auto"
          h={'16'}
          px={{ base: 4, md: 6 }}
          align="center"
          justify="space-between"
        >
          <Link href="/" display="flex" alignItems="center">
            <Image
              src={Logolight}
              alt="Quedemy - Home"
              h={{ base: 6, md: 6 }}
              w="auto"
              display="block"
              _dark={{ display: 'none' }}
            />
            <Image
              src={LogoDark}
              alt="Quedemy - Home"
              h={{ base: 6, md: 6 }}
              w="auto"
              display="none"
              _dark={{ display: 'block' }}
            />
          </Link>

          {/* Desktop nav */}
          <HStack gap={4} display={{ base: 'none', md: 'flex' }}>
            {links.map((link) => (
              <NavLink key={link.href} href={link.href}>
                {link.label}
              </NavLink>   
            ))}
            <ColorModeButton />
            {/* <Button variant={'solid'} fontWeight={'medium'} rounded={'md'}>
              Get Started Now
            </Button> */}
          </HStack>

          {/* Mobile toggle */}
          <HStack display={{ base: 'inline-flex', md: 'none' }}>
            <ColorModeButton />
            <IconButton
              aria-label="Toggle menu"
              children={open ? <LuX size={20} /> : <LuMenu size={20} />}
              variant="ghost"
              onClick={onToggle}
            />
          </HStack>
        </Flex>

        {/* Mobile panel */}
        {open && (
          <Box
            display={{ base: 'block', md: 'none' }}
            // borderTop="1px solid"
            borderTopWidth="1px"
            pb={4}
            height={'50vh'}
          >
            <Spacer mt={4} />
            <Stack as="nav" gap={4} px={4} pt={2}>
              {links.map((link) => (
                <NavLink key={link.href} href={link.href}>
                  {link.label}
                </NavLink>
              ))}
              <Spacer mt={4} />
              {/* <Button
                variant={'solid'}
                size={'sm'}
                fontWeight={'medium'}
                rounded={'md'}
              >
                Get Started Now
              </Button> */}
            </Stack>
          </Box>
        )}
      </Box>
    </>
  );
};

export const Navbar = React.memo(NavbarContent);
export default Navbar;
